<template>
  <div class="input-group w-25">
    <input type="text" class="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" autocomplete="off" name="search" placeholder="Search…" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="$emit('reset')">Reset</button>
  </div>
</template>

<script>
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    Dropdown,
  },
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
  emits: ['update:modelValue', 'reset'],
}
</script>
